import styles from './BlockOrdering.module.css'
import OrderingIcon  from '../../../assets/ordering-primary.svg?react'
import CheckOrderingIcon  from '../../../assets/ordering-checked.svg?react'
import UncheckOrderingIcon  from '../../../assets/ordering-unchecked.svg?react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useTopContextState } from '../../../context/TopContext'

interface Props {
  setFilters: (filters: any) => void
  filters: Record<string, any>
}

export default function BlockOrdering({ setFilters, filters }: Props) {
  const { t } = useTranslation()

  const { geoPermission } = useTopContextState()

  function handleLocationClick() {
    if (navigator.geolocation && geoPermission !== 'denied') {
      navigator.geolocation.getCurrentPosition(success, error)
    } else {
      console.log('Geolocation not supported')
    }
  }

  function success(position: any) {
    const latitude = position.coords.latitude
    const longitude = position.coords.longitude
    setFilters({
      ...filters,
      ordering: 'distance',
      user_lat: latitude,
      user_lon: longitude,
    })
  }

  function error() {
    console.log('Unable to retrieve your location')
  }

  return (
    <div className={styles.BlockOrdering}>
      <div className={styles.TitleOrdering}>
        <OrderingIcon /> <div className="ms-2">{t('ORD_BOX_TITLE')}</div>
      </div>
      <div className={styles.ListOrderingItems}>
        <div
          className={classNames(styles.OrderingItem, {
            [styles.OrderingItemActive]: filters.ordering === 'label',
          })}
          onClick={() => {
            setFilters({
              ...filters,
              ordering: 'label',
            })
          }}
        >
          <div>
            {filters.ordering === 'label' ? (
              <CheckOrderingIcon />
            ) : (
              <UncheckOrderingIcon />
            )}
          </div>
          <div className={styles.OrderingItemTitle}>
            {t('ORD_BOX_OPT_ALPHA_AZ')}
          </div>
        </div>
        <div
          className={classNames(styles.OrderingItem, {
            [styles.OrderingItemActive]: filters.ordering === '-label',
          })}
          onClick={() => {
            setFilters({
              ...filters,
              ordering: '-label',
            })
          }}
        >
          <div>
            {filters.ordering === '-label' ? (
              <CheckOrderingIcon />
            ) : (
              <UncheckOrderingIcon />
            )}
          </div>
          <div className={styles.OrderingItemTitle}>
            {t('ORD_BOX_OPT_ALPHA_ZA')}
          </div>
        </div>
        <div
          className={classNames(styles.OrderingItem, {
            [styles.OrderingItemActive]: filters.ordering === 'pictures_count',
          })}
          onClick={() => {
            setFilters({
              ...filters,
              ordering: 'pictures_count',
            })
          }}
        >
          <div>
            {filters.ordering === 'pictures_count' ? (
              <CheckOrderingIcon />
            ) : (
              <UncheckOrderingIcon />
            )}
          </div>
          <div className={styles.OrderingItemTitle}>
            {t('ORD_BOX_OPT_LESS_PHOTO')}
          </div>
        </div>
        <div
          className={classNames(styles.OrderingItem, {
            [styles.OrderingItemActive]: filters.ordering === 'distance',
            [styles.OrderingItemDisabled]: geoPermission === 'denied',
          })}
          onClick={() => {
            if (geoPermission !== 'denied') {
              handleLocationClick()
              setFilters({
                ...filters,
                ordering: 'distance',
              })
            }
          }}
        >
          <div>
            {filters.ordering === 'distance' ? (
              <CheckOrderingIcon />
            ) : (
              <UncheckOrderingIcon />
            )}
          </div>
          <div className={styles.OrderingItemTitle}>{t('ORD_BOX_OPT_DISTANCE')}</div>
        </div>
      </div>
    </div>
  )
}
